<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-n3">
        a) Which of the following solutions (each 0.50 M in both species) is <b>NOT</b> a buffer?
      </p>

      <v-radio-group
        v-model="inputs.multipleChoiceAnswer"
        class="ml-6 mb-0"
        :disabled="!allowEditing"
      >
        <v-radio v-for="option in options" :key="option.value" class="my-1" :value="option.value">
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <p class="mb-2">b) I think this because:</p>

      <p class="mb-n2">
        <s-textarea v-model="inputs.explainedResponse" outlined />
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import STextarea from '@/common/components/STextarea.vue';

export default {
  name: 'Question516',
  components: {
    STextarea,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        multipleChoiceAnswer: null,
        explainedResponse: null,
      },
      options: [
        {text: '$\\ce{NH4Cl}$ and $\\ce{NH3}$', value: 'ammoniumAndAmmonia'},
        {text: '$\\ce{H2CO3}$ and $\\ce{NaHCO3}$', value: 'carbonicAndBicarbonate'},
        {text: '$\\ce{HNO3}$ and $\\ce{NaNO3}$', value: 'nitricAndNitrate'},
        {text: '$\\ce{Na2HPO4}$ and $\\ce{Na3PO4}$', value: 'phosphates'},
      ],
    };
  },
};
</script>
